import { WLabel } from 'constants/enums';
import { wlEnvironment } from '../../config/config';
import { ICity } from 'Modules/SearchAddress/types';

export const getCurrentWl = () => {
  switch (wlEnvironment) {
    case WLabel.Globus:
      return WLabel.Globus;
    default:
      return WLabel.Default;
  }
};

export const currentWLabel = getCurrentWl();

export const isDefaultWLabel = currentWLabel === WLabel.Default;

export const selectByWL = (objByWl: { [key in WLabel]?: any }) => {
  if (objByWl[currentWLabel]) {
    return objByWl[currentWLabel];
  }

  return objByWl[WLabel.Default];
};

export const shopGroupByWL = selectByWL({ [WLabel.Globus]: 'globus' });

type InitialCity = Pick<ICity, 'id' | 'name' | 'coordinate'>;

const spb: InitialCity = {
  id: 1,
  name: 'Санкт-Петербург и ЛО',
  coordinate: {
    latitude: 59.93,
    longitude: 30.33,
  },
};

const msk: InitialCity = {
  id: 4,
  name: 'Москва и МО',
  coordinate: {
    latitude: 55.75,
    longitude: 37.61,
  },
};

export const currentCityInitialByWL: InitialCity = selectByWL({
  [WLabel.Default]: spb,
  [WLabel.Globus]: msk,
});
